<template>
  <!-- 对话框 -->
  <el-dialog title="公告内容" :visible.sync="show" :before-close="closeDialog" width="80%">

    <div style="height: 65vh;overflow-y: auto;" v-html="data">
    </div>

    <!-- 对话框底部按钮 -->
    <div style="display: flex;justify-content: center">
      <el-button @click="closeDialog">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        console.log(_this.data);


      },

    },
    data() {
      return {

        show: false,

      };
    },
    created() {
      _this = this;

    },
    methods: {

      // 关闭方法
      closeDialog() {

        _this.show = false;

        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }

      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>